<template>
  <div class="fullscreenContainer" :class="{ isDark: isDark }">
    <a-tooltip
      v-if="false"
      class="item"
      effect="dark"
      title="全屏查看"
      placement="top"
    >
      <div class="btn iconfont iconquanping" @click="toFullscreenShow" />
    </a-tooltip>
    <a-tooltip
      class="item"
      effect="dark"
      title="全屏"
      placement="top"
    >
      <div class="btn iconfont iconquanping1" @click="toFullscreenEdit" />
    </a-tooltip>
  </div>
</template>

<script>
import { fullscrrenEvent, fullScreen, extFullScreen } from '../utils';

/**
 * @Author: 王林
 * @Date: 2021-06-24 22:53:10
 * @Desc: 全屏
 */
export default {
  name: 'Fullscreen',
  props: {
    mindMap: {
      type: Object
    },
    isDark: {
      type: Boolean
    }
  },
  data() {
    return {
      isFullScreen: false
    };
  },
  created() {
    document[fullscrrenEvent] = () => {
      setTimeout(() => {
        this.mindMap.resize();
      }, 1000);
    };
  },
  methods: {
    // 全屏查看
    toFullscreenShow() {
      fullScreen(this.mindMap.el);
    },

    // 全屏编辑
    toFullscreenEdit() {
      extFullScreen(this.mindMap.el.parentNode.parentNode);
      // if (!this.isFullScreen) {
      // // this.$emit('fullScreen');
      //   fullScreen(this.mindMap.el.parentNode.parentNode);
      // // fullScreen(document.body);
      // } else {
      //   extFullScreen(this.mindMap.el.parentNode.parentNode);
      // }
      this.isFullScreen = !this.isFullScreen;
    }
  }
};
</script>

<style lang="less" scoped>
.fullscreenContainer {
  display: flex;
  align-items: center;

  &.isDark {
    .btn {
      color: hsla(0,0%,100%,.6);
    }
  }

  .item {
    margin-right: 12px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .btn {
    cursor: pointer;
  }
}
</style>
